// extracted by mini-css-extract-plugin
module.exports = {"tabs":"SpendingTabsPage_tabs__1mFbI"};